// extracted by mini-css-extract-plugin
module.exports = {"related-content-links":"_1hmNK","relatedContentLinks":"_1hmNK","related-content-link":"_1qvE3","relatedContentLink":"_1qvE3"};